<af-full-table
    class="w-100 h-100 trend-feedbacks-tab"
    [showImport]="false"
    [showExport]="false"
    [dataSource]="dataSource"
    (tableUpdateListener)="loadFeedbacks($event)"
    [filterEvent]="tableEvent.filter"
    [pageEvent]="tableEvent.page"
    [sortEvent]="tableEvent.sortBy"
    [totalElements]="totalElements"
    [filterFields]="filterFields"
    additionalSpinnerIds="trendFeedbacks"
    placeholderContext="trendFeedbacks"
    emptyStateIconName="ic_empty_state_no_data"
    emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
    totalElementsTranslationKey="i18n_af_labelTotalElementsTrendFeedbacks"/>
